module.exports = "<div :class=\"[fixed ? 'navbar-fixed' : '']\"> <nav> <div class=nav-wrapper> <a :href=logoHref :class=\"['brand-logo', logoPosition]\">{{logo}}</a> <ul :class=\"[autoHide ? 'hide-on-med-and-down' : '', linkPosition]\"> <slot></slot> </ul> <a v-if=sideNavId v-el:button-collapse href=#! :data-activates=sideNavId :class=collapseButtonClasses> <icon value=menu></icon> </a> </div> </nav> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../~/material-ui-vue/components/navbar/navbar.vue
 ** module id = 53
 ** module chunks = 0
 **/